import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import graphic from '../assets/images/graphic.png';
import Tree from '../components/Tree';

const mapStateToProps = ({ allPage }) => {
  const data = _.map(allPage, (value, key) => {
    // console.log('about', _.find(value, page => _.get(page, 'slug') === 'about-us'));
    return {
      key,
      ..._.find(value, page => _.get(page, 'slug') === 'about-us')
    };
  });
  // console.log('about keyBy', _.keyBy(data, 'key'));
  return {
    content: _.keyBy(data, 'key')
  };
};

const actions = {};

const mapDispatchToProps = (dispatch) => {
  return { actions: bindActionCreators(actions, dispatch) };
};

class AboutUs extends Component {
  render() {
    const { content, getContentLanguage, language } = this.props;
    const contentByLanguage = _.get(content, `${language}.acf`, {});
    const aboutContent = {
      ...contentByLanguage,
      banner: _.get(contentByLanguage, ['about_background', 'sizes', 'large']),
      bannerHistory: _.get(contentByLanguage, ['history_background', 'sizes', 'large']),
      history: _.map(contentByLanguage.history, val => ({
        title: val.year,
        description: val.description
      }))
    };
    return (
      <div className="about-page">
        <div className="history row no-gutters">
          <div className="banner col-12 col-lg-10">
            <img src={_.get(aboutContent, 'banner')} alt="" />
          </div>
          <div className="wrap-content col-12 col-lg-6">
            <div className="content offset-1 col-10 offset-md-2 col-md-8">
              <h2 className="paragraph content-head m-bottom-40">
                {_.get(aboutContent, 'title')}
              </h2>
              <h3 className="paragraph">{_.get(aboutContent, 'tagline')}</h3>

              {_.map(_.get(aboutContent, 'content'), (val, key) => (
                <p
                  key={`paragraph-${key}`}
                  className="paragraph"
                  dangerouslySetInnerHTML={{
                    __html: _.get(val, 'paragraph')
                  }}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="history-middle row no-gutters offset-1 offset-lg-0 align-items-start">
          <div className="history-graphic col-4 col-md-6 col-lg-2">
            <img className="graphic" src={graphic} alt="" />
          </div>
          <div className="history-content col-12 col-lg-4">
            <h2 className="history-header uppercase">{getContentLanguage('history')}</h2>
            <Tree dataSource={_.get(aboutContent, 'history')} name="tree-history" />
          </div>
          <div className="history-image col col-md-5">
            <img src={_.get(aboutContent, 'bannerHistory')} alt="" />
          </div>
        </div>
        <div className="vision row no-gutters">
          <div className="wrap-vision offset-1 col-10 offset-md-2 col-md-8">
            <h2 className="vision-header uppercase text-align-center">
              {_.get(aboutContent, 'vision.title')}
            </h2>
            <p
              className="vision-content text-align-center"
              dangerouslySetInnerHTML={{
                __html: _.get(aboutContent, 'vision.description')
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AboutUs);



// WEBPACK FOOTER //
// ./src/screens/AboutUs.js